import { useState } from 'react';
import { api } from '../api';

/** Redacted UCP insight (L14). Never shows tokens or full buyer data (N03). */
export function TechnicalPanel() {
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = async (open: boolean) => {
    if (!open) return;
    try {
      setData(await api.technical());
      setError(null);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Konnte Technikdaten nicht laden.');
    }
  };

  return (
    <details className="technical" onToggle={(event) => void load(event.currentTarget.open)}>
      <summary>Technikansicht · UCP-Schritte (bereinigt)</summary>
      {error && <p className="notice error">{error}</p>}
      {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </details>
  );
}
